import type {
  ActionPerformed,
  PushNotificationSchema,
  Token,
} from '@capacitor/push-notifications';

import { isCapacitorNativePlatform } from '~/lib/mobile/capacitor-bridge';

let pushNotificationsInitPromise: Promise<void> | null = null;

export function initPushNotifications(): Promise<void> {
  if (!isCapacitorNativePlatform()) return Promise.resolve();
  if (import.meta.env.VITE_ENABLE_PUSH !== '1') return Promise.resolve();
  if (pushNotificationsInitPromise) return pushNotificationsInitPromise;
  pushNotificationsInitPromise = runPushNotificationsInit();
  return pushNotificationsInitPromise;
}

async function runPushNotificationsInit(): Promise<void> {
  const { PushNotifications } = await import('@capacitor/push-notifications');

  let permStatus = await PushNotifications.checkPermissions();
  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') return;

  await PushNotifications.addListener('registration', (token: Token) => {
    window.dispatchEvent(
      new window.CustomEvent('skillarea:push:registration', {
        detail: { token: token.value },
      }),
    );
  });

  await PushNotifications.addListener('registrationError', (error) => {
    window.dispatchEvent(
      new window.CustomEvent('skillarea:push:registrationError', {
        detail: { error },
      }),
    );
  });

  await PushNotifications.addListener(
    'pushNotificationReceived',
    (notification: PushNotificationSchema) => {
      window.dispatchEvent(
        new window.CustomEvent('skillarea:push:received', {
          detail: { notification },
        }),
      );
    },
  );

  await PushNotifications.addListener(
    'pushNotificationActionPerformed',
    (notification: ActionPerformed) => {
      window.dispatchEvent(
        new window.CustomEvent('skillarea:push:action', {
          detail: { notification },
        }),
      );
    },
  );

  await PushNotifications.register();
}
